import { useState } from 'react';

// Escudo del colegio para reforzar identidad en las animaciones.
// Carga el archivo real si existe; si no, cae a un emblema de marca con los
// tokens del sistema (navy + dorado), claramente reemplazable.
//
// Escudo oficial en packages/frontend/public/img/ (escudo.webp optimizado +
// escudo.png de respaldo). Si no existiera, cae al emblema SVG.
export function BrandMark({ className }: { className?: string }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className={'gb-brand' + (className ? ' ' + className : '')} aria-hidden="true">
      {failed ? (
        <FallbackCrest />
      ) : (
        <picture className="gb-brand__pic">
          <source srcSet="/img/escudo.webp" type="image/webp" />
          <img
            className="gb-brand__img"
            src="/img/escudo.png"
            alt=""
            draggable={false}
            onError={() => setFailed(true)}
          />
        </picture>
      )}
    </span>
  );
}

// Emblema de respaldo: óvalo navy con borde dorado y monograma (silueta similar
// al escudo oficial, hasta colocar el archivo real).
function FallbackCrest() {
  return (
    <svg className="gb-brand__svg" viewBox="0 0 60 84" role="img" aria-hidden="true">
      <ellipse className="gb-crest__shield" cx="30" cy="42" rx="27" ry="39" />
      <ellipse className="gb-crest__inner" cx="30" cy="42" rx="20.5" ry="30.5" />
      <text className="gb-crest__mono" x="30" y="44" textAnchor="middle" dominantBaseline="middle">
        MC
      </text>
    </svg>
  );
}
